import { MatSnackBar } from '@angular/material/snack-bar';
import { MaintenanceService } from '../shared/maintenance/maintenance.service';
import { Component, OnInit } from '@angular/core';
import { TokenService } from '@morningstar/shared/auth';
import { useAnimation } from '@angular/animations';

@Component({
    selector: 'wsg-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  maintenanceMessage = '';
  processingMaintenance = false;
  userIsAuthenticated = false;

  constructor(private maintenanceService: MaintenanceService, private snackbar: MatSnackBar, private tokenService: TokenService) {

    this.userIsAuthenticated = tokenService.isAuthTokenValid();

    tokenService.userStatusChanged$.subscribe(user => {
      this.userIsAuthenticated = user.isAuthenticated;
    });
  }

  ngOnInit() {

    if (this.userIsAuthenticated) {
      this.processingMaintenance = true;
      this.maintenanceService.get()
                            .subscribe(maintenanceMessage => {
                              this.maintenanceMessage = maintenanceMessage.message;
                              this.processingMaintenance = false;
                            }, error => {
                              this.snackbar.open('Error retrieving maintenance', 'DISMISS', { duration: 2000 });
                              this.processingMaintenance = false;
                            });
    }
  }
}
